import React from 'react';

import styled, { css } from 'styled-components';

import Flex from 'components/Flex/Flex';
import GenericContainer from 'components/GenericContainer';
import Block from 'components/ModularBlocks/TwoBlockContent/components/Block';

import { TwoBlockContent as TwoBlockContentType } from 'interfaces/content-stack/modular-blocks/twoBlockContent';

interface BlockContainerProps {
  $reverse?: boolean;
  $reverseOrder?: boolean;
  $backgroundImageUrl?: string;
}

const BlockContainer = styled('div')<BlockContainerProps>(
  ({ theme, $reverse, $backgroundImageUrl, $reverseOrder }) => css`
    width: 100%;
    gap: 5rem;
    min-height: 35rem;
    padding: 6rem 0;
    display: flex;
    flex-direction: ${$reverse ? 'row-reverse' : 'row'};
    ${$backgroundImageUrl &&
    css`
      background-image: url(${$backgroundImageUrl});
    `}
    background-size: cover;

    @media (max-width: ${theme.breakpoints.lg}) {
      flex-direction: ${$reverseOrder ? 'column-reverse' : 'column'} !important;
      gap: 3rem;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      padding: 2rem 0;
    }
  `
);

const BlockWrapper = styled('div')(
  ({ theme }) => css`
    width: 50%;
    gap: 1.25rem;
    display: flex;
    flex-direction: column;

    @media (max-width: ${theme.breakpoints.lg}) {
      width: 100%;
    }
  `
);

export interface TwoBlockContentProps {
  data: TwoBlockContentType;
  className: string;
}

const TwoBlockContent: React.FC<TwoBlockContentProps> = ({ data }) => {
  const blockReference = data?.blockReference ? data.blockReference[0] : {};
  const { block, reverse, reverseOrder } = blockReference ?? {};

  return (
    <Flex w100 center styles={{ overflow: 'hidden' }}>
      <GenericContainer>
        <BlockContainer $reverse={reverse} $reverseOrder={reverseOrder}>
          {block?.map((item, index) => {
            const { blockOptions = {} } = item;
            const { contentAlignment, mobileContentAlignment } = blockOptions;

            return (
              <BlockWrapper key={index}>
                <Block contentAlign={contentAlignment} mobileContentAlign={mobileContentAlignment} data={item} />
              </BlockWrapper>
            );
          })}
        </BlockContainer>
      </GenericContainer>
    </Flex>
  );
};

export default TwoBlockContent;
